import { render, staticRenderFns } from "./PayConsultation.vue?vue&type=template&id=34472654&scoped=true&"
import script from "./PayConsultation.vue?vue&type=script&lang=js&"
export * from "./PayConsultation.vue?vue&type=script&lang=js&"
import style0 from "./PayConsultation.vue?vue&type=style&index=0&id=34472654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34472654",
  null
  
)

export default component.exports